import rootReducer from "../reducers";
import { applyMiddleware, compose, createStore } from "redux";
import promiseMiddleware from "redux-promise-middleware";
import thunk from "redux-thunk";

export default (initialState) => {
  const middleware = [thunk, promiseMiddleware()];

  const finalCreateStore = compose(applyMiddleware(...middleware))(createStore);

  const store = finalCreateStore(rootReducer, initialState);

  if (typeof window !== "undefined") {
    window.store = store;
  }

  return store;
};
